import { LOCALE_TYPE } from 'locales/locale';
import { initialGadgetEditValue } from 'redux/initial-state';
import { LocaleType } from 'types/constants/locale';
import {
  GadgetCommonModelGadgetTypeCodeEnum, GadgetEditModel, GadgetModel, SavedSearchCriteriaResponse,
} from 'types/entity';
import { ulid } from 'ulid';
import { getDefaultGadgetEditSizeAndName } from 'utils/gadget-setting';

export const gadgetEditToGadget = (
  entity: GadgetEditModel,
  locale: LocaleType,
): GadgetModel | undefined => {
  if (entity === undefined) { return undefined; }
  return {
    gadget_id: entity.gadget_id,
    original_gadget_id: entity.original_gadget_id,
    gadget_type_code: entity.gadget_type_code,
    gadget_contents_id: entity.gadget_contents_id,
    background_color: entity.background_color,
    background_image_url: entity.background_image_url,
    x_coordinates: entity.x_coordinates,
    y_coordinates: entity.y_coordinates,
    width: entity.width,
    height: entity.height,
    display_name: locale === LOCALE_TYPE.EN ? entity.display_name_en : entity.display_name_ja,
  };
};

export const newGadgetEdit = (gadgetContentsId: string, gadgetTypeCode: GadgetCommonModelGadgetTypeCodeEnum): GadgetEditModel => ({
  ...initialGadgetEditValue,
  ...getDefaultGadgetEditSizeAndName(gadgetTypeCode),
  gadget_id: ulid(),
  gadget_type_code: gadgetTypeCode,
  gadget_contents_id: gadgetContentsId,
  x_coordinates: 100,
  y_coordinates: 100,
});

export const newGadgetEditByCriteria = (
  gadgetContentsId: string,
  gadgetTypeCode: GadgetCommonModelGadgetTypeCodeEnum,
  criterias: SavedSearchCriteriaResponse[],
): GadgetEditModel => ({
  ...newGadgetEdit(gadgetContentsId, gadgetTypeCode),
  ...getSearchCriteriaNames(gadgetContentsId, criterias),
});

const getSearchCriteriaNames = (
  searchCriteriaId: string,
  criterias: SavedSearchCriteriaResponse[],
): GadgetEditModel => {
  const criteria = criterias.find((c) => c.search_criteria_id === searchCriteriaId);
  const display_name_ja = criteria?.display_name_ja || '';
  const display_name_en = criteria?.display_name_en;
  return { display_name_ja, display_name_en };
};
